import { render, staticRenderFns } from "./CardBanda.vue?vue&type=template&id=548dd94e&scoped=true"
import script from "./CardBanda.vue?vue&type=script&lang=js"
export * from "./CardBanda.vue?vue&type=script&lang=js"
import style0 from "./CardBanda.vue?vue&type=style&index=0&id=548dd94e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548dd94e",
  null
  
)

export default component.exports